module.exports = __webpack_public_path__ + "img/32.9d8a1e9b.png";